import React from 'react'

import UserIcon from "../../icons/user/user"
import {
    OPTION_ACTION_REQUIRED_USER,
    OPTION_ASSIGNED_TO_USER,
    OPTION_CURRENT_USER
} from "../../../fields3/generic/users/@const"

type Props = {
    className?  :   string
    disabled?   :   boolean
    size        :   26 | 22 | '26' | '22'
    userId      :   ID                   // if passes - display icon & label automatically
    palette?    :   'transparent' | 'gray'
    onDelete?   :   callback | null     // if set adds delete button
    onClick?    :   callback | null
    value?      :   any                 // this is what being passed when we set on click or on delete !!!
}

export default function PillUser(props: Props) {

    const onClick = (e:React.SyntheticEvent) => {

        // do not stop propagation yet !
        if (!props.onClick) return

        e.stopPropagation()
        // console.log("on click", props.value)
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        // console.log("on delete", props.value)
        if (props.onDelete) props.onDelete(props.value)
    }


    const classes = Classes(
        'ui5-pill-u user', 'gray',
        's-'+props.size,
        props.className
    );

    let pillLabel, pillIcon

    switch (props.userId) {

        case OPTION_ASSIGNED_TO_USER.value:
            pillLabel   = 'Assigned to user'
            pillIcon    = <div className="icon ui5-ico-13 i5-user m-l-5"/>
            break

        case OPTION_ACTION_REQUIRED_USER.value:
            pillLabel   = 'Action required user'
            pillIcon    = <div className="icon ui5-ico-13 i5-user m-l-5"/>
            break

        case OPTION_CURRENT_USER.value:
            pillLabel   = 'Current user'
            pillIcon    = <div className="icon ui5-ico-13 i5-user m-l-5"/>
            break

        default:
            const user = gd.session.users.get(props.userId)
            pillLabel   = _.get(user,'name', false)
            pillIcon    = <UserIcon className="avatar" userId={props.userId} size="22"/>
            break
    }




    return (
        <div className={classes} onClick={onClick}>
            {pillIcon}
            <div className="pill-label">{pillLabel}</div>
            {props.onDelete &&  !props.disabled && <div className="i5-close" onClick={onDelete} />}
        </div>
    )
}

PillUser.defaultProps = {
    size        : '26'
}
